import { useQuery } from '@tanstack/react-query'
import { sellerService } from '../services/seller.service'

export const sellerQueryKeys = {
  dashboard: ['seller', 'dashboard'] as const,
  inventory: ['seller', 'inventory-summary'] as const,
  usage: ['seller', 'usage'] as const,
  subscription: ['seller', 'subscription'] as const,
  permissions: ['seller', 'permissions'] as const,
}

export function useSellerDashboard() {
  return useQuery({
    queryKey: sellerQueryKeys.dashboard,
    queryFn: sellerService.getDashboard,
  })
}

export function useSellerInventorySummary() {
  return useQuery({
    queryKey: sellerQueryKeys.inventory,
    queryFn: sellerService.getInventorySummary,
  })
}

export function useSellerUsage() {
  return useQuery({
    queryKey: sellerQueryKeys.usage,
    queryFn: sellerService.getUsage,
  })
}

export function useSellerSubscription() {
  return useQuery({
    queryKey: sellerQueryKeys.subscription,
    queryFn: sellerService.getSubscription,
  })
}

export function useSellerPermissions() {
  return useQuery({
    queryKey: sellerQueryKeys.permissions,
    queryFn: sellerService.getPermissions,
  })
}
